export default "__VITE_ASSET__1311d5db__"